import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from '@cotyorg/ccx-molecules/Accordion';
import CategoryOption from '../CategoryOption';

const generateItemBodyContentClassNames = ({ accordionItemBodyColumns }) => (
  classNames('cell', {
    [`xsmall-${accordionItemBodyColumns}`]: accordionItemBodyColumns,
  })
);

// istanbul ignore next
const FilterAccordion = ({
  categories = [],
  toggleFilter,
  accordionMinusIconSrc,
  accordionPlusIconSrc,
  accordionItemTitleButtonExtraClass = 'filter__accordion-item-title',
  accordionItemBodyColumns = 12,
  isOpen,
  showProductCount,
}) => (
  <Accordion isOpen={isOpen}>
    {
      categories.map(({ name: categoryName, options = [] }) => (
        <AccordionItem extraClass="filter__accordion-item" key={categoryName}>
          <AccordionItemTitle
            extraClass="grid-x align-center"
            buttonExtraClass={accordionItemTitleButtonExtraClass}
            minusIconSrc={accordionMinusIconSrc}
            plusIconSrc={accordionPlusIconSrc}
          >
            {categoryName}
          </AccordionItemTitle>
          <AccordionItemBody contentExtraClassNames="filter__accordion-item-content">
            {
              options.map(({
                name,
                color,
                count,
                isSelected,
              }) => (
                <div key={name} className="grid-x align-center">
                  <div className={generateItemBodyContentClassNames({ accordionItemBodyColumns })}>
                    <CategoryOption
                      categoryName={categoryName}
                      optionName={name}
                      color={color}
                      count={count}
                      toggleFilter={toggleFilter}
                      isSelected={isSelected}
                      showProductCount={showProductCount}
                    />
                  </div>
                </div>
              ))
            }
          </AccordionItemBody>
        </AccordionItem>
      ))
    }
  </Accordion>
);

FilterAccordion.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
  })).isRequired,
  toggleFilter: PropTypes.func.isRequired,
  accordionMinusIconSrc: PropTypes.string.isRequired,
  accordionPlusIconSrc: PropTypes.string.isRequired,
  accordionItemTitleButtonExtraClass: PropTypes.string,
  accordionItemBodyColumns: PropTypes.number,
  isOpen: PropTypes.bool.isRequired,
  showProductCount: PropTypes.bool.isRequired,
};

export default FilterAccordion;
